import CrudPage from "../components/CrudPage";

const STATUS = { bekliyor: "Bekliyor", tamamlandi: "Tamamlandı", iptal: "İptal" };
const STATUS_STYLE = { bekliyor: "bg-blue-50 text-blue-600", tamamlandi: "bg-emerald-50 text-emerald-600", iptal: "bg-gray-100 text-gray-500" };

export default function Appointments() {
  return (
    <CrudPage
      title="Randevular"
      subtitle="Randevularınız takvim ile senkron çalışır"
      module="appointments"
      endpoint="/appointments"
      addLabel="Yeni Randevu"
      defaultValues={{ status: "bekliyor" }}
      filters={[{ name: "status", label: "Durum", options: Object.entries(STATUS).map(([v, l]) => ({ value: v, label: l })) }]}
      columns={[
        { key: "name", label: "Ad Soyad", render: (r) => <span className="font-medium">{r.name}</span> },
        { key: "phone", label: "Telefon" },
        { key: "date", label: "Tarih" },
        { key: "time", label: "Saat" },
        { key: "description", label: "Açıklama" },
        { key: "status", label: "Durum", render: (r) => <span className={`px-2 py-1 text-xs font-semibold ${STATUS_STYLE[r.status] || ""}`}>{STATUS[r.status] || "-"}</span> },
      ]}
      fields={[
        { name: "name", label: "Ad Soyad", required: true },
        { name: "phone", label: "Telefon" },
        { name: "address", label: "Adres", colSpan: 2 },
        { name: "date", label: "Tarih", type: "date", required: true },
        { name: "time", label: "Saat", type: "time", required: true },
        { name: "status", label: "Durum", type: "select", options: Object.entries(STATUS).map(([v, l]) => ({ value: v, label: l })) },
        { name: "description", label: "Açıklama", type: "textarea" },
      ]}
    />
  );
}
